"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./IconDropdown.css");

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// Our main component
var IconDropdown = /*#__PURE__*/function (_Component) {
  _inherits(IconDropdown, _Component);

  var _super = _createSuper(IconDropdown);

  function IconDropdown(props) {
    var _this;

    _classCallCheck(this, IconDropdown);

    _this = _super.call(this, props);
    _this.state = {
      icons: [{
        name: 'Behance'
      }, {
        name: 'Deviantart'
      }, {
        name: 'Dribbble'
      }, {
        name: 'Facebook'
      }, {
        name: 'Flickr'
      }, {
        name: 'Foursquare'
      }, {
        name: 'Google'
      }, {
        name: 'Googleplus'
      }, {
        name: 'Instagram'
      }, {
        name: 'Linkedin'
      }, {
        name: 'Pinterest'
      }, {
        name: 'Snapchat'
      }, {
        name: 'Tumblr'
      }, {
        name: 'Twitter'
      }, {
        name: 'Vimeo'
      }, {
        name: 'Vine'
      }, {
        name: 'Wordpress'
      }, {
        name: 'Youtube'
      }, {
        name: 'Protection'
      }, {
        name: 'Ads'
      }, {
        name: 'Analytics'
      }, {
        name: 'Badge'
      }, {
        name: 'Bin'
      }, {
        name: 'Briefcase'
      }, {
        name: 'Calendar'
      }, {
        name: 'Coin'
      }, {
        name: 'Copyright'
      }, {
        name: 'Crown'
      }, {
        name: 'Discount'
      }, {
        name: 'Entrepreneur'
      }, {
        name: 'Eshop'
      }, {
        name: 'Facilities'
      }, {
        name: 'Favorite'
      }, {
        name: 'FavoriteFill'
      }, {
        name: 'Fax'
      }, {
        name: 'Groups'
      }, {
        name: 'Home'
      }, {
        name: 'InfinitySign'
      }, {
        name: 'Info'
      }, {
        name: 'Label'
      }, {
        name: 'Locked'
      }, {
        name: 'Nacebel'
      }, {
        name: 'Newsletter'
      }, {
        name: 'OpeningHours'
      }, {
        name: 'OpenMap'
      }, {
        name: 'PaperPlane'
      }, {
        name: 'Post'
      }, {
        name: 'Search'
      }, {
        name: 'Settings'
      }, {
        name: 'Share'
      }, {
        name: 'Team'
      }, {
        name: 'Video'
      }, {
        name: 'Michelin'
      }, {
        name: 'Michelin2star'
      }, {
        name: 'Michelin3star'
      }, {
        name: 'GaultMillau'
      }, {
        name: 'Keywords'
      }, {
        name: 'StarFill'
      }, {
        name: 'Breakfast'
      }, {
        name: 'Gym'
      }, {
        name: 'HotelBar'
      }, {
        name: 'PetsAllowed'
      }, {
        name: 'Restaurant'
      }, {
        name: 'Spa'
      }, {
        name: 'SwimmingPool'
      }, {
        name: 'TwentyFourHourReception'
      }, {
        name: 'WeelchairFriendly'
      }, {
        name: 'Wifi'
      }, {
        name: 'PlennyColor'
      }],
      show: false
    };
    return _this;
  }

  _createClass(IconDropdown, [{
    key: "showHideHandler",
    value: function showHideHandler(e) {
      this.setState({
        show: e
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _ref;

      var _this$state = this.state,
          icons = _this$state.icons,
          show = _this$state.show,
          _this$props = this.props,
          active = _this$props.active,
          _this$props$dropdown_ = _this$props.dropdown_position,
          dropdown_position = _this$props$dropdown_ === void 0 ? 'left' : _this$props$dropdown_,
          onChange = _this$props.onChange;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "iconDropdown ".concat(show ? 'active' : ''),
        onMouseLeave: function onMouseLeave() {
          return _this2.showHideHandler(false);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "iconDropdownCurrent",
        onClick: function onClick() {
          return _this2.showHideHandler(true);
        }
      }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        name: active ? active : 'Entrepreneur'
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "iconDropdownList",
        style: (_ref = {}, _defineProperty(_ref, dropdown_position, '0'), _defineProperty(_ref, "transformOrigin", "top ".concat(dropdown_position)), _ref)
      }, icons.map(function (value, index) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: value.name === active ? 'active' : '',
          key: index
        }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
          name: value.name,
          onClick: function onClick() {
            return onChange ? onChange(value.name) : undefined;
          }
        }));
      })));
    }
  }]);

  return IconDropdown;
}(_react.Component);

exports["default"] = IconDropdown;